import React, { Component } from 'react';
import { render } from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import * as FormActions from '../actions/FormActions';
import { structureData, fetchStoredWoodBeamValues, fetchJSON } from '../common';
import Form from '../components/Form';
import WoodBeamSummaryContainer from '../containers/WoodBeamSummaryContainer';
import { productConfigurator } from '../lib/configSingleton';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Popover } from 'bootstrap';

let Configurator = (function() {
  class Configurator extends Component {

    constructor(props) {
      super(props);

      this.state = { 
        ConfiguratorStore: props.ConfiguratorStore,
        dataLoaded: false
      };
      this.loadData();
      this.isInitialized = false;  // ADD: Flag to prevent multiple init calls
    }
  
    loadData() {
      const { dispatch } = this.props;
      const actions = bindActionCreators(FormActions, dispatch);

      const jsonURL = productConfigurator.jsonURL; 
      const fieldsJsonURL = productConfigurator.fieldsJsonURL;

      Promise.all([fetchJSON(jsonURL), fetchJSON(fieldsJsonURL)]).then((responses) => {
        const newState = structureData(responses[0], responses[1]);
        const storedState = fetchStoredWoodBeamValues(newState);

        actions.setNewState(storedState);
        this.setState({ dataLoaded: true });
      }).catch((error) => {
        console.error(error.message);
        actions.setNewState(Map({error: 'Error Loading Wood Beam Configurator'}));
      });
    }

    componentDidUpdate(prevProps) { 
      if (this.state.dataLoaded && this.props.ConfiguratorStore !== prevProps.ConfiguratorStore && !this.isInitialized) {
        this.initializePopover();
        this.isInitialized = true;
      }
    }
    
    initializePopover() {
      const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
      const isMobile = () => window.matchMedia('(max-width: 991px)').matches;

      popoverTriggerList.forEach(trigger => {
        const popover = new Popover(trigger, { 
          trigger: 'click',
          title: '<span class="popover-close"></span>Tool tip:',
          html: true
        });

        const handleOutsideClick = (e) => {
          if (e.target.classList.contains('popover-close')) {
            popover.hide();
          }
          if (
            popover.tip && 
            !popover.tip.contains(e.target) && 
            !trigger.contains(e.target)
          ) {
            popover.hide();
          }
        };

        const lockScroll = () => {
          if (isMobile()) {
            document.body.style.overflow = 'hidden';
          }
          trigger.classList.add('popover-open');
          setTimeout(() => document.addEventListener('click', handleOutsideClick), 0);
        };

        const unlockScroll = () => {
          document.body.style.overflow = '';
          trigger.classList.remove('popover-open');
          document.removeEventListener('click', handleOutsideClick);
        };

        trigger.addEventListener('shown.bs.popover', lockScroll);
        trigger.addEventListener('hidden.bs.popover', unlockScroll);

        window.addEventListener('resize', () => { 
          popover.hide();
          trigger.classList.remove('popover-open');
        });
      });
    }

    render() {
      const state = this.props.ConfiguratorStore;
      const woodBeam = state.get('product');
      const fields = state.get('fields');
      const fieldOrder = state.get('fieldOrder');
      const error = state.get('error');
    
      if (typeof(fields) === 'undefined' || !(fields.size > 0)) {
        return (
          <div className="loader">
              <DotLottieReact
                src="/wp-content/themes/blockshoon/assets/animations/lottie-loading.json"
                loop
                autoplay
              />
          </div>
        );
      }
    
      return (
        <div className="configurator-container">
          <WoodBeamSummaryContainer />
          <div className="form">
            <Form product={woodBeam} fields={fields} sections={fieldOrder} />
          </div>
        </div>
      );
    }
  }
  
  Configurator = connect(({ ConfiguratorStore }) => ({ ConfiguratorStore }))(Configurator);
  return Configurator;
})();

export default Configurator;